import type { EnvConfig } from "@/types/env-config";
import { create } from "zustand";

type State = {
  config: EnvConfig;
};

type EnvConfigState = State;

const useEnvConfigStore = create<EnvConfigState>(() => ({
  config: window.__ENV_CONFIG__,
}));

export const getTheme = () => useEnvConfigStore.getState().config.theme;
export const getPlatform = () => useEnvConfigStore.getState().config.platform;
export const getServeConfig = () => {
  const serveConfig = useEnvConfigStore.getState().config.serve;

  return {
    ...serveConfig,
    locales: serveConfig.locales.map((l) => l.toLowerCase()),
    defaultLocale: serveConfig.locales[0],
  };
};
export const getApiHost = () => useEnvConfigStore.getState().config.api.host;
export const getAssetHost = () => useEnvConfigStore.getState().config.api.assetsHost;
export const getAssetCacheVersion = () => useEnvConfigStore.getState().config.api.cacheVersion;
export const getDeployEnv = () => useEnvConfigStore.getState().config.deployEnv;
export const getAesKey = () => useEnvConfigStore.getState().config.encryption.aesKey;
export const getAesIv = () => useEnvConfigStore.getState().config.encryption.aesIv;
export const getFeatures = () => useEnvConfigStore.getState().config.features;
export const getCmsRevalidate = () => useEnvConfigStore.getState().config.features.cms.revalidate;
export const getDirectusApiHost = () => useEnvConfigStore.getState().config.directus.apiHost;
export const getDirectusToken = () => useEnvConfigStore.getState().config.directus.apiToken;
export const getDirectusUpdatePostReadCountFlowId = () =>
  useEnvConfigStore.getState().config.directus.updatePostReadCountFlowId;
export const getAndroidDownload = () => useEnvConfigStore.getState().config.features.androidDownload;
export const getIosDownload = () => useEnvConfigStore.getState().config.features.iosDownload;
export const getFirebaseConfig = () => useEnvConfigStore.getState().config.firebase;
export const getDynamicConfig = () => useEnvConfigStore.getState().config.features.dynamicConfig;
export const getDynamicConfigUrl = () => useEnvConfigStore.getState().config.features.dynamicConfigUrl;
export const getShareLinkUrl = () => useEnvConfigStore.getState().config.features.shareLinkUrl;

export const useTheme = () => useEnvConfigStore((s) => s.config.theme);
export const useServeArea = () => useEnvConfigStore((s) => s.config.serve.area);
export const useServeLocales = () => useEnvConfigStore((s) => s.config.serve.locales);
export const usePlatform = () => useEnvConfigStore((s) => s.config.platform);
export const useServeCountryCodes = () => useEnvConfigStore((s) => s.config.serve.countryCodes);
export const useDefaultCountryCode = () => useEnvConfigStore((s) => s.config.serve.countryCodes[0]);
export const useDeployEnv = () => useEnvConfigStore((s) => s.config.deployEnv);
export const useEnableChat = () => useEnvConfigStore((s) => s.config.features.enableChat);
export const useEnableRegisterGetCoin = () => useEnvConfigStore((s) => s.config.features.enableRegisterGetCoin);
export const useEnableChatUserId = () => useEnvConfigStore((s) => s.config.features.enableChatUserId);
